import EventActionProto from '../event-action-proto';

module.exports = class ExportPdfResult extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {

        if (gd.modal.isOpen && gd.modal.exportTimelineToPdf) {
            gd.bus.triggerEvent('print-pdf-ready', this.data);
        } else {
            const link = 'https://www.goodday.work/pdf/' + this.data.pdfFile;
            //gd.growl.successSticky('The pdf file is ready. <a href="' + link + '">' + link + '</a>');
            gd.growl.successSticky('The pdf file is ready. ' + link);
        }
    }
};


